export default "__VITE_ASSET__CQuV$omw__"